/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : AI 로직 관련 API
 * 버전 : 1.0
 * 파일명 : Main.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * 수정 : 2025-07-04, 강동형 : 저작권 추가, 홍보효과가 좋은 학교 API 추가, postBestSchoolsToday 리퀘스트 바디 제거, 공고맞춤 추천 API 추가
 * ================================================================ */

import axios from "axios"
import { getAuthToken } from "./Auth"

const API_URL = process.env.REACT_APP_API_URL

export const getUnvisitedTop3 = async()=>{
    try{
      const token = getAuthToken()
      const response = await axios.get(`${API_URL}/search-unvisited-schools-top3`,{
        headers:{
          "Content-Type":"application/json",
          Authorization: `Bearer ${token}`
        }
      })
        return response.data
      }
    catch(error){
      if(axios.isAxiosError(error)){
          if(error.response){
            const response = error.response
            return response.data
          }
        }
    }
}

export const postBestSchoolsToday = async()=>{
  try{
    const token = getAuthToken()
    const response = await axios.post(`${API_URL}/search-best-schools-today`,{},{
      headers:{
        "Content-Type":"application/json",
        Authorization: `Bearer ${token}`
      }
    })
      return response.data
    }
  catch(error){
    if(axios.isAxiosError(error)){
        if(error.response){
          const response = error.response
          return response.data
        }
      }
  }
}

interface postTodaysEffectiveSchoolsParams{
  school_type?: 'highschool'|'university'|'both'
}

export const postTodaysEffectiveSchools = async({school_type = 'both'}:postTodaysEffectiveSchoolsParams = {})=>{
  try{
    const token = getAuthToken()
    const response = await axios.post(`${API_URL}/search-promotion-effective-schools`,{},{
      params:{
        school_type:school_type
      },
      headers:{
        "Content-Type":"application/json",
        Authorization: `Bearer ${token}`
      }
    })
      return response.data
    }
  catch(error){
    if(axios.isAxiosError(error)){
        if(error.response){
          const response = error.response
          return response.data
        }
      }
  }
}

export const postTodaysRecommendSchool = async(announcement_id : number)=>{
  try{
    const token = getAuthToken()
    const response = await axios.post(`${API_URL}/recommend-schools-for-announcement2`,{},{
      params:{
        announcement_id : announcement_id
      },
      headers:{
        "Content-Type":"application/json",
        Authorization: `Bearer ${token}`
      }
    })
      return response.data
    }
  catch(error){
    if(axios.isAxiosError(error)){
        if(error.response){
          const response = error.response
          return response.data
        }
      }
  }
}